import {
  Button,
  Card,
  Col,
  List,
  message,
  Row,
  Space,
  Typography,
  Modal,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Get from "../services/Get";

const InsuranceHistory = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const getData = async (page = 1) => {
    try {
      setLoading(true);
      const res = await Get.InsuranceHistory(page); // Send page number
      console.log(res);

      if (res.error) {
        message.error(res.error);
        return;
      }

      const { data, total, per_page, current_page } = res; // Laravel response
      setHistory(data);
      setPagination({
        current: current_page,
        pageSize: per_page,
        total: total,
      });
    } catch (error) {
      message.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleViewDetails = (item) => {
    setSelectedItem(item);
    setModalVisible(true);
  };

  const handleDownloadPDF = async (item) => {
    try {
      setLoading(true);
      console.log(item);

      const res = await Get.DownloadInsurancePDF(item.id);

      if (res.error) {
        message.error(res.error);
        return;
      }
  
      const pdfLink = res.data.download_url;
  
      // Create a link and trigger download
      const link = document.createElement('a');
      link.href = pdfLink;
      link.setAttribute('download', `Insurance-${item.policy_no}.pdf`); // Optional: Set download filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      message.success("PDF downloaded successfully!");
    } catch (error) {
      message.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedItem(null);
  };

  return (
    <div className="layout-content">
      <Row justify="center" className="mb-4">
        <Col xs={20} md={20}>
          <Space
            direction="vertical"
            size="middle"
            style={{
              display: "flex",
            }}
          >
            <Row justify={"end"}>
              <Button
                type="primary"
                className="form-btn"
                onClick={() => navigate(`/user/insurance`)}
              >
                Go Back
              </Button>
            </Row>
            <Card>
              <List
                header={
                  <Typography.Title level={4}>
                    Insurance History
                  </Typography.Title>
                }
                bordered
                loading={loading}
                dataSource={history}
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                  onChange: (page) => getData(page), // Fetch new page data
                  position: "bottom",
                  align: "center",
                }}
                renderItem={(item) => (
                  <List.Item className="list__insurence"
                    actions={[
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() => handleViewDetails(item)}
                      >
                        View Details
                      </Button>,
                      <Button
                        type="primary"
                        className="form-btn"
                        onClick={() => handleDownloadPDF(item)}
                      >
                        Download PDF
                      </Button>,
                    ]}
                  >
                    <List.Item.Meta
                      title={item.customer_name}
                      description={
                        <>
                          Policy No:{" "}
                          <Typography.Text>{item.policy_no}</Typography.Text>
                          <br />
                          Provider:{" "}
                          <Typography.Text>
                            {item.productProviderName}
                          </Typography.Text>
                          <br />
                          Amount:{" "}
                          <Typography.Text>₹{item.amount}</Typography.Text>
                        </>
                      }
                    />
                  </List.Item>
                )}
              />
            </Card>
          </Space>
        </Col>
      </Row>

      {/* Modal for View Details */}
      <Modal
        title="Insurance Details"
        open={modalVisible}
        onCancel={handleCloseModal}
        footer={[
          <Button key="close" onClick={handleCloseModal}>
            Close
          </Button>,
        ]}
      >
        {selectedItem && (
          <Table
            dataSource={[
              {
                label: "Customer Name",
                value: selectedItem.customer_name,
              },
              { label: "Policy No", value: selectedItem.policy_no },
              {
                label: "Provider",
                value: selectedItem.productProviderName,
              },
              { label: "Amount", value: `₹${selectedItem.amount}` },
              { label: "VLE Margin", value: `₹${selectedItem.vleMargin}` },
              { label: "Product", value: `₹${selectedItem.product_name}` },
              { label: "Start Date", value: selectedItem.rsd },
              { label: "End Date", value: selectedItem.red },
            ]}
            columns={[
              { title: "Field", dataIndex: "label", key: "label" },
              { title: "Details", dataIndex: "value", key: "value" },
            ]}
            pagination={false}
          />
        )}
      </Modal>
    </div>
  );
};

export default InsuranceHistory;
